import React, { Component } from "react";
import PromiseBar from "./PromiseBar";

class PromiseBarContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      percentage: 0,
      active: false,
      barVariant: this.props.variant
    };
    this.interval = undefined;
  }

  componentWillUnmount() {
    this.reset();
  }

  start = () => {
    this.state.active = true;
    this.interval = setInterval(() => {
      var percentage =
        this.state.percentage >= 99 ? 99 : this.state.percentage + 1;

      this.setState({ percentage: percentage, barVariant: this.props.variant });
    }, 50);
  };

  error = () => {
    this.state.active = false;
    this.interval = setInterval(() => {
      var percentage =
        this.state.percentage <= 0 ? 0 : this.state.percentage - 1;

      this.setState({ percentage: percentage, barVariant: "danger" });

      if (percentage === 0) {
        this.reset();
      }
    }, 50);
  };

  reset = () => {
    //must not call this.setState(...)!
    this.state.percentage = 0;
    this.state.active = false;
    this.state.barVariant = this.props.variant;
    this.setState((prevState, props) => {
      return {
        percentage: 0,
        active: false,
        barVariant: props.variant
      };
    });
    clearInterval(this.interval);
  };

  render() {
    return (
      <PromiseBar
        variant={this.state.barVariant}
        percentage={this.state.percentage}
        active={this.state.active}
        reset={this.reset}
      />
    );
  }
}

export default PromiseBarContainer;
